"use client";
import { Box, Button, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React, { useEffect, useState } from "react";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";

interface AddToCartButtonProps {
  data: any;
  reloadCartButton: any;
  setReloadCartButton: any;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  data,
  reloadCartButton,
  setReloadCartButton,
}) => {
  const currencyCode = useCurrencyCode();
  const [price, setPrice] = useState({
    totalMrp: "",
    totalAmount: "",
    totalSave: "",
  });

  const handleNaviagteToCart = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (Array.isArray(data)) {
      const totalAmount = data.reduce(
        (sum: number, item: any) => sum + (item?.amount || 0),
        0
      );
      const totalMrp = data.reduce(
        (sum: number, item: any) => sum + (item?.mrp || 0),
        0
      );
      const discount = data.reduce(
        (sum: number, item: any) => sum + (item?.discount || 0),
        0
      );

      setPrice((prev) => ({
        ...prev,
        totalAmount: totalAmount,
        totalMrp: totalMrp,
        totalSave: discount,
      }));
    }
    setReloadCartButton();
  }, [reloadCartButton, setReloadCartButton, data]);

  return (
    <Box
      sx={{
        background: { xs: "#fff", sm: "none" },
        position: "fixed",
        bottom: -1,
        zIndex: 1000,
        width: {
          xs: "-webkit-fill-available",
          sm: "50%",
          md: "40%",
          lg: "25%",
        },
        right: 0,
        display: data?.length > 0 ? "block" : "none",
      }}
    >
      <Button
        variant="contained"
        onClick={handleNaviagteToCart}
        sx={{
          margin: "0.5rem",
          width: "-webkit-fill-available",
          borderRadius: "999px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 18px",
          background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
          boxShadow: "0 8px 24px rgba(18, 53, 36, 0.25)",
          textTransform: "none",
          fontWeight: 600,
          "&:hover": {
            background: "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              justifyContent: "left",
              display: "grid",
              alignItems: "center",
              marginLeft: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                {currencyCode}
                {price?.totalAmount}
              </Typography>
              &nbsp; &nbsp;
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "line-through",
                }}
              >
                {currencyCode}
                {price?.totalMrp}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                textTransform: "capitalize",
                textAlign: "start",
              }}
            >
              Save {currencyCode}
              {price?.totalSave}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            Add to Cart <KeyboardArrowRightIcon />
          </Typography>
        </Box>
      </Button>
    </Box>
  );
};

export default AddToCartButton;
